
import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
import { Modal } from 'react-bootstrap';
import { commonGet } from '../../../services/CommonService';


const ViewProjects = ({ user }) => {

    const [postModal, setPostModal] = useState(false);
    const [projects, setProjects] = useState([]);

    const closemodal = async () => {
        setPostModal(false);
    }

    useEffect(() => {

        console.log(user);
        getProjects();

    }, []);

    const getProjects = async () => {

        const reqparam = {
            pageno: '-1',
            ptype: 'USERPROJECTS',
            query: { userid: user.id }

        }

        const EduResponse = await commonGet(reqparam);
        setProjects(EduResponse.data);
    }

    const[description ,setDescription] =useState(null);
    const viewDescription =async(listval) =>{
        setDescription(listval.description);
        setPostModal(true);
    }


    return (<>
        <div className="col-12">
            <div className="card">

                <div className="card-body">
                    <div className="table-responsive">
                        <div id="job_data" className="dataTables_wrapper">
                            <table
                                className="display w-100 dataTable "
                                id="example5"
                                role="grid"
                                aria-describedby="example5_info"
                            >
                                <thead>
                                    <tr role="row">
                                        <th className="sorting_asc" style={{ width: "177px" }}>
                                            Name
                                        </th>
                                        <th className="sorting" style={{ width: "278px" }}>
                                            Duration
                                        </th>
                                        <th className="sorting" style={{ width: "278px" }}>
                                            Descrption
                                        </th>

                                    </tr>
                                </thead>

                                <tbody>
                                   

                                    {projects.map((listValue, index) => {
                                        return (
                                            <tr  key={index}>
                                                <td>{listValue.name}</td>
                                                <td>{listValue.duration}</td>
                                                <td>{listValue.description.slice(0,100)}..</td>
                                                <button type="button" onClick={()=>viewDescription(listValue)} className="btn btn-info" >View Descrption</button>  
                                            </tr>
                                        );
                                    })}

                                </tbody>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal className="modal fade" size="lg" show={postModal} onHide={setPostModal} >
            <div className="" role="document">
                <div className="">
                    <form >
                        <div className="modal-header">

                            <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <textarea
                                className="form-control"
                                rows="8"
                                id="comment" value ={description}
                            ></textarea>

                        </div>
                        {/*<div className="modal-footer">
                              <button type="submit" className="btn btn-primary" >Add</button>  
                              <button type="button" onClick={()=> setPostModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
</div>*/}
                    </form>

                </div>
            </div>
        </Modal>
    </>)
}

export default ViewProjects